import { render, staticRenderFns } from "./CsrWarning.vue?vue&type=template&id=b56cbec6"
import script from "./CsrWarning.vue?vue&type=script&lang=js"
export * from "./CsrWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports